// src/constants/brand.js
//
// lowesheds.com and homedepotshed.com are two separate storefronts that share
// ONE Supabase database with the ShedX platform, and both are owned by the same
// dealer (Edwin). `dealer_id` therefore cannot tell the two catalogs apart —
// the `brand` column on `sheds_inventory` is the discriminator.
//
// Every PUBLIC storefront query must be scoped to this brand. Without it this
// site would also render homedepotshed.com's catalog, because the two share a
// dealer row. It additionally keeps Edwin's unpublished ShedX rows (brand
// 'SE Yard' / 'SE Yard Solutions') off this storefront.
//
// The same string is listed in ShedX's STANDALONE_STOREFRONT_BRANDS
// (shedx/src/services/shedService.js) so these rows stay hidden from the
// ShedX public site and its /dealer/:slug and /embed pages.
export const STOREFRONT_BRAND = 'Lowes Sheds';
